import { Context } from '@nuxt/types';

export default async function(context: Context) {
  // UA tracking
  context.app.$ua.trackLoginEvent();
}
